//import { Unenroll_Users_From_device } from "./oprations/Device"

//const BASE_URL = "http://localhost:4000/api"
//const BASE_URL = "http://137.97.126.110:4002/api"
//const BASE_URL = `${window.location.origin}/api`
 const host = window.location.hostname
 const BASE_URL = host === "137.97.126.110" ? `http://${host}:4004/api` : `${window.location.origin}/api`


export const apiClient = {

  BASE_URL:BASE_URL,
  //ORGANIZATION  THIS API ONLY ACCESS BY ORGANIZATION
  SIGNUP_API: BASE_URL + "/auth/create-organization",
  LOGIN_API: BASE_URL + "/auth/login-organization",
  CHANGE_PASSWORD_ORG: BASE_URL + "/auth/change-password-org",
  PROFILE_DATA: BASE_URL + "/auth/get-organization",
  ORG_TIMEZONE: BASE_URL + "/time-zone/org/set-timezone",


  CREATE_ORDER: BASE_URL + "/payment/create-order",
  VERIFY_PAYMENT: BASE_URL + "/payment/verify-payment",
  PAYMENT_DETAILS: BASE_URL + "/payment/get-payments",

  GET_NOTIFICATION: BASE_URL + "/org/notifications",
  DELETE_NOTIFICATION: BASE_URL + "/org/notifications/:id",
  READMARK_NOTIFICATION: BASE_URL + "/org/notifications/read/:id",
  READMARKALL_NOTIFICATION: BASE_URL + "/org/notifications/read-all",
  UNREADCOUNT_NOTIFICATION:BASE_URL + "/org/notifications/unread-count",

  CREATE_MANAGER: BASE_URL + "/auth/signup/manager",
  GET_MANAGER: BASE_URL + "/org/get-managers",
  UPDATE_MANAGER: BASE_URL + "/org/update-manager",
  DELETE_MANAGER: BASE_URL + "/org/delete-manager",


  GET_ALL_USERS: BASE_URL + "/org/get-users",
  CREATE_USER: BASE_URL + "/org/create-user/organization",
  DELETE_USER_ORG: BASE_URL + "/org/delete-user/organization",
  DELETE_ALL_USERS_ORG: BASE_URL + "/org/delete-all-users",
  UNENROLL_USER_FROM_DEVICES_ORG: BASE_URL + "/org/unenroll-user/organization",
  ENROLL_USER_ORG: BASE_URL + "/org/enroll-user/organization",
  ENROLLED_USER_ORG: BASE_URL + "/org/enroll-user/organization",
  UPDATE_USER_ORG:BASE_URL + "/org/update-user/organization", 
  IMPORT_USER_ORG:BASE_URL + "/org/import-template",
  EXPORT_USER_ORG:BASE_URL + "/org/export-template",

  REMOVE_FINGERPRINT_FROM_DEVICE: BASE_URL + "/org/remove-fringerprint-device/organization",
  DELETE_USER_FROM_DEVICE_ORG: BASE_URL + "/org/user-delete-from-device/organization",

  // GET_ALL_DEVICES: BASE_URL + "/org/get-devices",
  CREATE_DEVICE_ORG: BASE_URL + "/org/create-device/organization",
  GET_DEVICE_ORG: BASE_URL + "/org/get-devices/organization",
  UPDATE_DEVICE_ORG: BASE_URL + "/org/update-device/organization",
  DELETE_DEVICE_ORG: BASE_URL + "/org/delete-device/organization",

  GET_ATTENDANCE_ORG: BASE_URL + "/org/get-attendance-org",

  GET_SOFTWARE_PLAN: BASE_URL + "/org/software-plan",
  GET_HARDWARE_PLAN: BASE_URL + "/org/hardware-plan",
  SOFTWAREPLAN_PAYMENT: BASE_URL + "/org/software-plan",
  HARDWAREPLAN_PAYMENT: BASE_URL + "/org/hardware-plan",

  GIVE_MANAGER_ACCESS_ORG: BASE_URL + "/org/give-permission/manager",

  GET_DEVICE_HISTORY_ORG: BASE_URL + "/org/device-status-history",
  
  WALLET_TRACKING_ORG: BASE_URL + "/org/wallet-live-tracking",

  //MANAGER API THIS API ONLY ACCESS BY MANAGER.

  MANAGER_LOGIN: BASE_URL + "/auth/login/manager",
  MANAGER_DETAILS: BASE_URL + "/auth/manager",
  CHANGE_PASSWORD_MANAGER: BASE_URL + "/auth/change-password-manager",

  TIMEZONE: BASE_URL + "/time-zone/set-timezone",

  CREATE_DEVICE: BASE_URL + "/add-device",
  GET_DEVICE: BASE_URL + "/get-device",
  UPDATE_DEVICE: BASE_URL + "/update-device",
  DELETE_DEVICE: BASE_URL + "/delete-device",
  DELETE_USER_FROM_DEVICE: BASE_URL + "/delete-users-from-device",
  UNENROLLED_USER_FROM_DEVICE: BASE_URL + "/unenroll-users-from-device",

  ENROLL_USER: BASE_URL + "/enrolled-user",
  GET_USER: BASE_URL + "/get-users",
  UPDATE_USER: BASE_URL + "/update-user",
  DELETE_USER: BASE_URL + "/delete-user",
  DELETE_ALL_USERS_MNG: BASE_URL + "/delete-all-users",
  UNENROLL_USER_FROM_DEVICE: BASE_URL + "/unenroll-user",
  IMPORT_USER_MNG:BASE_URL + "/import-template",
  EXPORT_USER_MNG:BASE_URL + "/export-template",


  GET_ATTENDANCE: BASE_URL + '/get-attendance',

  POST_CONTACT: BASE_URL + '/v4/contact/send-message',
  POST_FEEDBACK: BASE_URL + '/v4/feedback/send-feedback',



  GET_HOLIDAYSLIST: BASE_URL + "/manager-holidayslist",
  POST_HOLIDAYSLIST: BASE_URL + "/manager-holidayslist",
  PUT_HOLIDAYSLIST: BASE_URL + "/manager-holidayslist",
  DELETE_HOLIDAYSLIST: BASE_URL + "/manager-holidayslist",

  APPROVED_LEAVE: BASE_URL + "/manager-approved-leave",
  GET_LEAVES: BASE_URL + "/manager-get-leaves",
  DELETE_LEAVES: BASE_URL + "/manager-delete-leave",

  FORGOT_PASSWORD: BASE_URL + "/auth/forgot-password/user",
  FORGOT_MANAGER_PASSWORD: BASE_URL + "/auth/forgot-password/manager",

  CREATE_USER_MNG: BASE_URL + "/create-user/manager",
  ENROLLED_USER_MNG: BASE_URL + "/enrolled-user",
  ENROLL_USER_MNG: BASE_URL + "/enrolled-user",

  GET_DEVICE_HISTORY_MNG: BASE_URL + "/device-status-history",

  WALLET_TRACKING_MNG: BASE_URL + "/wallet-live-tracking",

  // User APIs........
    LOGIN_URL: BASE_URL + "/user-login",
    USER_DETAILS_URL: BASE_URL + "/get-user-details",
    USER_CHANGE_PASSWORD:BASE_URL + "/user-change-password",

    USER_ATTENDANCE_URL:BASE_URL + "/get-attendance",
    USER_ADD_REMARK_ATTENDANCE_URL:BASE_URL + "/add-remark-attendance",

    USER_LEAVES_URL:BASE_URL + "/get-user-leave",
    USER_APPLY_LEAVE_URL:BASE_URL + "/apply-leave",

    USER_HOLIDAYS_URL:BASE_URL + "/get-user-holidays"

}

// /enrolled-user/:userId/:deviceId/:step/:FingerId
// router.post('/create-user/manager',Middleware.ManagerAuth,Middleware.IsManagerAuth,User_Bussinees.Create_User)
// router.post('/enrolled-user/:userId/:deviceId',Middleware.ManagerAuth,Middleware.IsManagerAuth,User_Bussinees.Enroll_User)
// router.post('/create-device/organization', Middleware.OrgAuth, Middleware.IsOrgAuth, DeviceOperations.Add_Device)
// router.get('/get-devices/organization', Middleware.OrgAuth, Middleware.IsOrgAuth, DeviceOperations.Get_Devices)
// router.put('/update-device/organization/:deviceId', Middleware.OrgAuth, Middleware.IsOrgAuth, DeviceOperations.UpdateDevice)
// router.delete('/delete-device/organization/:deviceId', Middleware.OrgAuth, Middleware.IsOrgAuth, DeviceOperations.DeleteDevice)
